module.exports = __webpack_public_path__ + "img/swiper2.1b9e6083.jpg";